export default "__VITE_PUBLIC_ASSET__a2eb592a__"